module.exports = __webpack_public_path__ + "static/scale-model-of-thoroughbred-park-in-lexington-kentucky-921a1a90cabe86e561c9fc1d52938ecd.png";